import angular from 'angular';

const services = angular.module('applicationModule.webPagesServices', []);

services.factory('Webpages', ['WebpagesAPI', 'Upload', 'AppsoupAPI', '$http', (WebpagesAPI, Upload, AppsoupAPI, $http) => {
    'use strict';

    const API_URL_WWW_HEADER = `${AppsoupAPI.API_URL}/app/web-pages/headers/www/`;
    const API_URL_WWW_FOOTER = `${AppsoupAPI.API_URL}/app/web-pages/footers/www/`;
    const API_URL_WWW_SIDEBAR = `${AppsoupAPI.API_URL}/app/web-pages/sidebars/www/`;
    const API_URL_WEB_ACTIONS = `${AppsoupAPI.API_URL}/app/web-pages/web-actions/www/`;

    const checkFiles = (file, image) => {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }
        if (angular.isDefined(image)) {
            files.push(image);
            names.push('image');
        }
        return {files, names};
    };

    const checkFilesPage = (file, nipFile, fileUserGroups) => {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }
        if (angular.isDefined(nipFile)) {
            files.push(nipFile);
            names.push('nip_file');
        }
        if (angular.isDefined(fileUserGroups)) {
            files.push(fileUserGroups);
            names.push('user_groups');
        }
        return {files, names};
    };

    return {
        all(appId, pageId, layout) {
            return WebpagesAPI.all(appId, pageId, layout)
                .then(response => response.data);
        },
        getPages(appId, pageId, params) {
            return WebpagesAPI.getPages(appId, pageId, params)
                .then(response => response.data);
        },
        get(id, appId) {
            return WebpagesAPI.get(id, appId);
        },
        publicAll(appId) {
            return WebpagesAPI.publicAll(appId);
        },
        save(data, file, nipFile, fileUserGroups, editMode, fileUploaded) {
            const API_URL = `${AppsoupAPI.API_URL}/app/web-pages`;
            let files;
            if (editMode) {
                if (angular.isDefined(file) || angular.isDefined(nipFile) || angular.isDefined(fileUserGroups)) {
                    files = checkFilesPage(file, nipFile, fileUserGroups);
                    const newfields = angular.extend(data, {_method: 'PUT'});

                    return Upload.upload({
                        url: `${API_URL}/${data.id}`,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: newfields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                }
            } else {
                if (angular.isDefined(file) || angular.isDefined(nipFile) || angular.isDefined(fileUserGroups)) {
                    files = checkFilesPage(file, nipFile, fileUserGroups);

                    return Upload.upload({
                        url: API_URL,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: data,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                }
            }
            return WebpagesAPI.store(data, editMode, fileUploaded);
        },
        remove(id, appId) {
            return WebpagesAPI.remove(id, appId);
        },
        create(appId, editMode, websiteId) {
            return WebpagesAPI.create(appId, editMode, websiteId);
        },
        tags(appId, text) {
            return WebpagesAPI.tags(appId, text);
        },
        tree(appId, limit, search) {
            return WebpagesAPI.tree(appId, limit, search)
                .then(response => response.data);
        },
        changeOrder(data) {
            return WebpagesAPI.changeOrder(data);
        },
        changeOrderExtreme(data) {
            return WebpagesAPI.changeOrderExtreme(data);
        },
        publish(appId, pageId) {
            return WebpagesAPI.publish(appId, pageId);
        },
        savePageHistory(appId, pageId) {
            return WebpagesAPI.savePageHistory(appId, pageId);
        },
        preview(appId, pageId, type) {
            return WebpagesAPI.preview(appId, pageId, type);
        },
        getHistory(appId, pageId) {
            return WebpagesAPI.getHistory(appId, pageId);
        },
        deleteHistory(appId, pageId) {
            return WebpagesAPI.deleteHistory(appId, pageId);
        },
        restoreHistory(appId, pageId) {
            return WebpagesAPI.restoreHistory(appId, pageId);
        },
        saveVersion(version, file, image, editMode) {
            const API_URL = `${AppsoupAPI.API_URL}/app/web-pages/versions/save`;
            let files;
            if (editMode) {
                if (angular.isDefined(file) || angular.isDefined(image)) {
                    files = checkFiles(file, image);
                    const newfields = angular.extend(version, {_method: 'PUT'});

                    return Upload.upload({
                        url: `${API_URL}/${version.id}`,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: newfields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                }
            } else {
                if (angular.isDefined(file) || angular.isDefined(image)) {
                    files = checkFiles(file, image);

                    return Upload.upload({
                        url: API_URL,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: version,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                }
            }
            return WebpagesAPI.saveVersion(version, editMode);
        },
        getVersions(appId, versionId) {
            return WebpagesAPI.getVersions(appId, versionId);
        },
        deleteVersion(appId, versionId) {
            return WebpagesAPI.deleteVersion(appId, versionId);
        },
        copy(pageId) {
            return WebpagesAPI.copy(pageId);
        },
        getAllHeaders(appId, params) {
            return WebpagesAPI.getListHeaders(appId, params)
                .then(response => response.data);
        },
        saveHeader(data, editMode) {
            if (editMode) {
                return $http.put(`${API_URL_WWW_HEADER}${data.id}`, data);
            } else {
                return $http.post(API_URL_WWW_HEADER, data);
            }
        },
        deleteHeader(appId, id) {
            return $http.delete(`${API_URL_WWW_HEADER}${id}`);
        },
        createHeader(appId, editMode) {
            return $http.get(`${API_URL_WWW_HEADER}create`, {params: {application_id: appId, edit_mode: editMode}});
        },
        autocompletePages(appId, text) {
            return $http.get(`${API_URL_WWW_HEADER}autocomplete/${appId}/${text}`);
        },
        getHeader(appId, headerId) {
            return $http.get(`${API_URL_WWW_HEADER}${headerId}`);
        },
        getAllFooters(appId, params) {
            return WebpagesAPI.getListFooters(appId, params)
                .then(response => response.data);
        },
        saveFooter(data, editMode) {
            if (editMode) {
                return $http.put(`${API_URL_WWW_FOOTER}${data.id}`, data);
            } else {
                return $http.post(API_URL_WWW_FOOTER, data);
            }
        },
        deleteFooter(appId, id) {
            return $http.delete(`${API_URL_WWW_FOOTER}${id}`);
        },
        removeHeaderElement(id, headerId, key) {
            return $http.delete(`${API_URL_WWW_HEADER}remove-header-element/${id}`, {
                params: {
                    header_id: headerId,
                    key: key
                }
            });
        },
        changeOrderHeaders(data) {
            const url = `${API_URL_WWW_HEADER}change-order/`;
            return $http.post(url, data);
        },
        changeOrderFooters(data) {
            const url = `${API_URL_WWW_FOOTER}change-order/`;
            return $http.post(url, data);
        },
        removeFooterElement(id, footerId, key) {
            return $http.delete(`${API_URL_WWW_FOOTER}remove-footer-element/${id}`, {
                params: {
                    footer_id: footerId,
                    key: key
                }
            });
        },
        autocompleteHeaders(headerId, key, search) {
            return $http.get(`${API_URL_WWW_HEADER}autocomplete-header/${headerId}/${key}/${search}`);
        },
        autocompleteFooters(headerId, key, search) {
            return $http.get(`${API_URL_WWW_FOOTER}autocomplete-header/${headerId}/${key}/${search}`);
        },
        createFooter(appId, editMode) {
            return $http.get(`${API_URL_WWW_FOOTER}create`, {params: {application_id: appId, edit_mode: editMode}});
        },
        getFooter(appId, footerId) {
            return $http.get(`${API_URL_WWW_FOOTER}${footerId}`);
        },
        saveElementHeader(data, images, editMode) {
            let files;
            if (editMode) {
                if (angular.isDefined(images) && Object.keys(images).length > 0) {
                    files = checkFiles(images);
                    const newFields = angular.extend(data, {_method: 'PUT'});

                    return Upload.upload({
                        url: `${API_URL_WWW_HEADER}${data.id}`,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: newFields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.put(`${API_URL_WWW_HEADER}${data.id}`, data);
                }
            } else {
                if (angular.isDefined(images) && Object.keys(images).length > 0) {
                    files = checkFiles(images);

                    return Upload.upload({
                        url: API_URL_WWW_HEADER,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: data,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.post(API_URL_WWW_HEADER, data);
                }
            }
        },
        saveElementFooter(data, images, editMode) {
            let files;
            if (editMode) {
                if (angular.isDefined(images) && Object.keys(images).length > 0) {
                    files = checkFiles(images);
                    const newFields = angular.extend(data, {_method: 'PUT'});

                    return Upload.upload({
                        url: `${API_URL_WWW_FOOTER}${data.id}`,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: newFields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.put(`${API_URL_WWW_FOOTER}${data.id}`, data);
                }
            } else {
                if (angular.isDefined(images) && Object.keys(images).length > 0) {
                    files = checkFiles(images);

                    return Upload.upload({
                        url: API_URL_WWW_FOOTER,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: data,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.post(API_URL_WWW_FOOTER, data);
                }
            }
        },
        getAllActions(appId) {
            return $http.get(API_URL_WEB_ACTIONS, {params: {application_id: appId}});
        },
        generateCSV(appId, type, startDate, endDate) {
            return $http.post(`${API_URL_WEB_ACTIONS}report/`, {
                application_id: appId,
                type: type,
                start_date: startDate,
                end_date: endDate
            });
        },
        getAllSidebars(appId, params) {
            return WebpagesAPI.getListSidebars(appId, params)
                .then(response => response.data);
        },
        saveSidebar(data, editMode) {
            if (editMode) {
                return $http.put(`${API_URL_WWW_SIDEBAR}${data.id}`, data);
            } else {
                return $http.post(API_URL_WWW_SIDEBAR, data);
            }
        },
        deleteSidebar(appId, id) {
            return $http.delete(`${API_URL_WWW_SIDEBAR}${id}`);
        },
        createSidebar(appId, editMode) {
            return $http.get(`${API_URL_WWW_SIDEBAR}create`, {params: {app_id: appId, edit_mode: editMode}});
        },
        getSidebar(appId, sidebarId) {
            return $http.get(`${API_URL_WWW_SIDEBAR}${sidebarId}`);
        },
        removeSidebarElement(id, sidebarId, key) {
            return $http.delete(`${API_URL_WWW_SIDEBAR}remove-sidebar-element/${id}`, {
                params: {
                    sidebar_id: sidebarId,
                    key: key
                }
            });
        },
        changeOrderSidebars(data) {
            const url = `${API_URL_WWW_SIDEBAR}change-order/`;
            return $http.post(url, data);
        },
        autocompleteSidebars(sidebarId, key, search) {
            return $http.get(`${API_URL_WWW_SIDEBAR}autocomplete-sidebar/${sidebarId}/${key}/${search}`);
        },
        saveElementSidebar(data, images, editMode) {
            let files;
            if (editMode) {
                if (angular.isDefined(images) && Object.keys(images).length > 0) {
                    files = checkFiles(images);
                    const newFields = angular.extend(data, {_method: 'PUT'});

                    return Upload.upload({
                        url: `${API_URL_WWW_SIDEBAR}${data.id}`,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: newFields,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.put(`${API_URL_WWW_SIDEBAR}${data.id}`, data);
                }
            } else {
                if (angular.isDefined(images) && Object.keys(images).length > 0) {
                    files = checkFiles(images);

                    return Upload.upload({
                        url: API_URL_WWW_SIDEBAR,
                        method: 'POST',
                        sendObjectsAsJsonBlob: false,
                        fields: data,
                        file: files.files,
                        fileFormDataName: files.names
                    });
                } else {
                    return $http.post(API_URL_WWW_SIDEBAR, data);
                }
            }
        },
        export(appId, pageId, moduleId) {
            return WebpagesAPI.export(appId, pageId, moduleId);
        },
        updateProducerPages(appId, producerPages) {
            return WebpagesAPI.updateProducerPages(appId, producerPages);
        },
        changePagesOrder(data) {
            return WebpagesAPI.changePagesOrder(data);
        }
    };
}]);

services.service('WebpagesAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/app/web-pages/`;

    this.all = (appId, pageId, layout) =>
        $http.get(API_URL, {params: {application_id: appId, parent_id: pageId, layout: layout}});

    this.getListFooters = (appId, params) =>
        $http.get(`${API_URL}footers/www`, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});

    this.getListHeaders = (appId, params) =>
        $http.get(`${API_URL}headers/www`, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});

    this.getListSidebars = (appId, params) =>
        $http.get(`${API_URL}sidebars/www`, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});

    this.getPages = (appId, pageId, params) =>
        $http.get(`${API_URL}get-pages/pagination`, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId,
                page_id: pageId
            })
        });

    this.get = id =>
        $http.get(`${API_URL}${id}`);

    this.publicAll = appId =>
        $http.get(`${API_URL}public-all/${appId}`);

    this.store = (data, editMode, fileUploaded) => {
        if (editMode) {
            return $http.put(`${API_URL}${data.id}`, data, {params: {file_uploaded: fileUploaded}});
        } else {
            return $http.post(`${AppsoupAPI.API_URL}/app/web-pages`, data);
        }
    };

    this.remove = id =>
        $http.delete(`${API_URL}${id}`);

    this.create = (appId, editMode, websiteId) =>
        $http.get(`${API_URL}create`, {params: {application_id: appId, edit_mode: editMode, webpage_id: websiteId}});

    this.tags = (appId, text) =>
        $http.get(`${API_URL}tags/${appId}`, {params: {search: text}});

    this.tree = (appId, limit, search) =>
        $http.get(`${API_URL}tree/${appId}`, {params: {limit: limit, search: search}});

    this.changeOrder = data => {
        const url = `${API_URL}change-order/`;
        return $http.post(url, data);
    };

    this.changeOrderExtreme = data => {
        const url = `${API_URL}change-order-extreme/`;
        return $http.post(url, data);
    };

    this.publish = (appId, id) => {
        const url = `${API_URL}publish/`;
        return $http.get(`${url}${appId}/${id}`);
    };

    this.savePageHistory = (appId, id) => {
        const url = `${API_URL}save/`;
        return $http.get(`${url}${appId}/${id}`);
    };

    this.preview = (appId, id, type) => {
        const url = `${API_URL}preview/`;
        return $http.get(`${url}${appId}/${id}/${type}`);
    };

    this.getHistory = (appId, id) => {
        const url = `${API_URL}history/`;
        return $http.get(`${url}${appId}/${id}`);
    };

    this.restoreHistory = (appId, id) => {
        const url = `${API_URL}history-restore/`;
        return $http.get(`${url}${appId}/${id}`);
    };

    this.deleteHistory = (appId, id) => {
        const url = `${API_URL}history-delete/`;
        return $http.get(`${url}${appId}/${id}`);
    };

    this.getVersions = (appId, id) => {
        const url = `${API_URL}versions/index/`;
        return $http.get(`${url}${appId}/${id}`);
    };

    this.saveVersion = (version, editMode) => {
        const url = `${API_URL}versions/save/`;
        if (editMode) {
            return $http.put(`${url}${version.id}`, version);
        } else {
            return $http.post(url, version);
        }
    };

    this.deleteVersion = (appId, id) => {
        const url = `${API_URL}versions/delete/`;
        return $http.get(`${url}${appId}/${id}`);
    };

    this.getActionConfig = (pageId, moduleId) => {
        const url = `${API_URL}action-config/`;
        return $http.get(`${url}${pageId}/${moduleId}`);
    };

    this.getActionInfoToDelete = (pageId, moduleId) => {
        const url = `${API_URL}action-info/`;
        return $http.get(`${url}${pageId}/${moduleId}`);
    };

    this.copy = id => {
        const url = `${API_URL}copy/`;
        return $http.get(`${url}${id}`);
    };

    this.export = (appId, pageId, moduleId) =>
        $http.post(`${API_URL}export/`, {application_id: appId, page_id: pageId, module_id: moduleId});

    this.updateProducerPages = (appId, producerPages) =>
        $http.post(`${API_URL}update-producer-pages/`, {
            application_id: appId,
            producer_pages: producerPages
        });

    this.changePagesOrder = data => {
        const url = `${API_URL}change-pages-order/`;
        return $http.post(url, data);
    };
}]);

export default services;